if (document.querySelector('.tt-wrapper')) {

  function getFestivalTimeParts() {
    var parts = new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(new Date());

    var hour = 0;
    var minute = 0;

    parts.forEach(function (part) {
      if (part.type === 'hour') {
        hour = parseInt(part.value, 10);
      }
      if (part.type === 'minute') {
        minute = parseInt(part.value, 10);
      }
    });

    return {
      hour: hour,
      minute: minute,
    };
  }

  document.querySelector('.tt-wrapper').addEventListener('scroll', function () {
    var scrollPos = this.scrollLeft;
    var ttMaster = document.querySelector('.tt-master');
    if (scrollPos > 0) {
      ttMaster.classList.add('small-view');
    } else {
      if (window.innerWidth > 640) {
        ttMaster.classList.remove('small-view');
      }
      ttMaster.classList.remove('small-view');
    }
  
  });

  if (window.innerWidth < 640) {
    document.querySelector('.tt-master').classList.add('small-view');
    
  }

  document.querySelector('.tt-nav__quick__available').addEventListener('click', function () {
    if (this.classList.contains('active')) {
      this.innerHTML = 'Nog te koop';
      this.classList.remove('active');
      document.querySelectorAll('.tt-master__venues__venue').forEach(function (venue) {
        venue.classList.remove('hidden');
      });
      document.querySelectorAll('.tt-venue').forEach(function (venue) {
        venue.classList.remove('hidden');
      });
      document.querySelectorAll('.dimmed').forEach(function (dimmed) {
        dimmed.classList.remove('hidden');
      });
    } else {
      this.innerHTML = 'Toon alles';
      this.classList.add('active');
      filterTimetableShows();
    }
  });

  // Opens the venue info
  document.querySelectorAll('.tt-master__venues__venue').forEach(function (venue) {
    venue.addEventListener('click', function () {
      var target = this.querySelector('.venue-info');
      target.classList.toggle('is-visible');
    });
  });

  function initTimetablePosition() {
    var festivalTime = getFestivalTimeParts();
    var hourWidth = parseFloat(getComputedStyle(document.querySelector('.tt-wrapper')).getPropertyValue('--hour-width'));
    var baseHour = 15;
    if (document.querySelector('.tt-wrapper--kind')) {
      baseHour = 14;
    }
    var hour = festivalTime.hour - baseHour;


    var scrollLength = hour * hourWidth * 16;
   

    function updateIndicator() {
      var festivalTime = getFestivalTimeParts();
      var currentHour = festivalTime.hour;
      var currentMinute = festivalTime.minute;
      var hourOffset = currentHour - baseHour;
      var indicatorPos = (hourOffset * hourWidth * 16) + ((currentMinute / 60) * hourWidth * 16);

      document.querySelector('.tt__current-time').style.left = indicatorPos + 'px';
    }

    if (hour >= 0) {
      updateIndicator();
      document.querySelector('.tt-wrapper').scrollLeft = scrollLength;
      setInterval(updateIndicator, 60000);
    } else {
      // Before festival hours — scroll to the first event
      var wrapper = document.querySelector('.tt-wrapper');
      var entries = document.querySelectorAll('.tt-venue__entries__entry:not(.tt-venue__entries__entry--time-unknow)');
      var minLeft = Infinity;
      entries.forEach(function (entry) {
        var el = entry;
        var left = 0;
        while (el && el !== wrapper) {
          left += el.offsetLeft;
          el = el.offsetParent;
        }
        if (left < minLeft) minLeft = left;
      });
      if (minLeft < Infinity) {
        wrapper.scrollLeft = Math.max(0, minLeft - 32);
      }
    }
  }

  // Run only if .tt-wrapper exists
  if (document.querySelector('.tt-wrapper')) {
    initTimetablePosition();
  }




  function filterTimetableShows() {
    document.querySelectorAll('.tt-venue').forEach(function (venue) {
      var venueName = venue.dataset.name;
      var masterVenue = document.querySelector('.tt-master__venues__venue[data-venue="' + venueName + '"]');
      var availableChildren = venue.querySelectorAll('.tt-venue__entries__entry[data-filter="available"]');
      document.querySelectorAll('.dimmed').forEach(function (dimmed) {
        dimmed.classList.add('hidden');
      });
      if (availableChildren.length > 0) {
        venue.classList.add('has-shows');
      } else {
        venue.classList.add('hidden');
        masterVenue.classList.add('hidden');
      }
    });
  }
} // if tt-wrapper

var currentPathTT = window.location.pathname;
var basePathTT = currentPathTT.includes('kinderparade') ? 'blokkenschema-kinderparade' : 'blokkenschema';

// Show calendar without requiring a click
const ttDatepickerEl = document.querySelector('.tt-datepicker');
var datepickerTimetable = ttDatepickerEl ? ttDatepickerEl.flatpickr({
  minDate: '2026-06-19',
  maxDate: '2026-08-30',
  enable: [
    {
      from: '2026-06-19',
      to: '2026-06-28',
    },
    {
      from: '2026-07-03',
      to: '2026-07-19',
    },
    {
      from: '2026-07-24',
      to: '2026-08-09',
    },
    {
      from: '2026-08-14',
      to: '2026-08-30',
    },
  ],
  dateFormat: 'd-m-Y',
  static: true,
  theme: 'airbnb',
  yearSelector: false,
  postition: 'below',
  locale: {
    firstDayOfWeek: 1, // Set Monday as the first day of the week
    weekdays: {
      shorthand: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
      longhand: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    },
    months: {
      shorthand: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
      longhand: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
    },
  },

  onChange: function (_, dateStr) {
    window.location.href = '/'+basePathTT+'?dag=' + dateStr;
  },
}) : null;




function setDataViewForElements(viewType) {
  document.querySelectorAll('.tt-page-wrapper, .tt-page-wrapper *[data-view], .tt-nav__types__listview').forEach(function (el) {
    el.setAttribute('data-view', viewType);
  });
  // Also set data-view on the toggle container for correct indicator
  var toggle = document.querySelector('.tt-nav__view-toggle');
  if (toggle) {
    toggle.setAttribute('data-view', viewType);
  }
  // Set or update the viewType cookie handy when switching between kinderparade and programma
  document.cookie = 'viewType=' + encodeURIComponent(viewType) + '; path=/; max-age=31536000';
  console.log('setted view to: '+ viewType);
  // Auto-open current slots when switching to timeslot view
  if (viewType === 'timeslot') {
    requestAnimationFrame(autoOpenCurrentSlots);
  }
}

if (document.querySelector('.tt-nav__types__listview')) {
  document.querySelectorAll('.tt-nav__view-toggle__child[data-set-view]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (this.dataset.setView === 'grid' || this.dataset.setView === 'timeslot') {
        setDataViewForElements(this.dataset.setView);
      }
    });
  });
}





// ─── Timeslot accordion ──────────────────────────────────────────────────────

function openTimeslot(slot) {
  var entries = slot.querySelector('.tt-timeslot__entries');
  if (entries) {
    entries.style.maxHeight = entries.scrollHeight + 'px';
    slot.classList.add('is-open');
  }
}

function closeTimeslot(slot) {
  var entries = slot.querySelector('.tt-timeslot__entries');
  if (entries) {
    entries.style.maxHeight = '0';
    slot.classList.remove('is-open');
  }
}

function autoOpenCurrentSlots() {
  var slots = document.querySelectorAll('.tt-timeslot');
  if (!slots.length) return;
  var currentHour = 0;
  if (typeof getFestivalTimeParts === 'function') {
    currentHour = getFestivalTimeParts().hour;
  } else {
    currentHour = new Date().getHours();
  }

  // Collect all slot hours in order
  var slotHours = [];
  slots.forEach(function (slot) {
    var header = slot.querySelector('.tt-timeslot__time');
    if (!header) return;
    var match = header.textContent.trim().match(/(\d+):/);
    if (match) slotHours.push(parseInt(match[1], 10));
  });

  var firstSlotHour = slotHours.length ? slotHours[0] : null;

  // If before the first slot, open the first slot
  if (firstSlotHour !== null && currentHour < firstSlotHour) {
    openTimeslot(slots[0]);
    return;
  }

  if (currentHour >= 15 || currentHour === 0) {
    var hoursToOpen = [currentHour, currentHour === 23 ? 0 : currentHour + 1];
    slots.forEach(function (slot) {
      var header = slot.querySelector('.tt-timeslot__time');
      if (!header) return;
      var match = header.textContent.trim().match(/(\d+):/);
      if (!match) return;
      var slotHour = parseInt(match[1], 10);
      if (hoursToOpen.indexOf(slotHour) !== -1) {
        openTimeslot(slot);
      }
    });
  }
}

function initTimeslotAccordion() {
  var slots = document.querySelectorAll('.tt-timeslot');
  if (!slots.length) return;

  // Collapse all, set up click handlers
  slots.forEach(function (slot) {
    var entries = slot.querySelector('.tt-timeslot__entries');
    if (entries) {
      entries.style.maxHeight = '0';
      entries.style.overflow = 'hidden';
    }
    var header = slot.querySelector('.tt-timeslot__time');
    if (header) {
      header.addEventListener('click', function () {
        var isOpen = slot.classList.contains('is-open');
        if (isOpen) {
          closeTimeslot(slot);
        } else {
          openTimeslot(slot);
        }
      });
    }
  });
}

if (document.querySelector('.tt-timeslots')) {
  initTimeslotAccordion();
}

//check for cookie and set view type accordingly
var viewTypeCookie = document.cookie.split('; ').find(row => row.startsWith('viewType='));
var defaultViewType = window.innerWidth < 640 ? 'timeslot' : 'grid';
if (window.innerWidth < 640) {
  setDataViewForElements('timeslot');
} else {
  if (viewTypeCookie) {
    var viewType = decodeURIComponent(viewTypeCookie.split('=')[1]);
    if (viewType === 'grid' || viewType === 'timeslot') {
      setDataViewForElements(viewType);
    } else {
      setDataViewForElements(defaultViewType);
    }
  } else {
    setDataViewForElements(defaultViewType);
  }
}
